<template>

  <b-card v-if="showSubview">

    <div v-if="canceled !=true">
      <div class="d-flex justify-content-between align-items-start mb-1">
        <span class="badge bg-light-primary text-sm" style="font-size:11px;">{{plan.title}}</span>
      </div>
      <div class="d-flex justify-content-start mb-1">
        <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
        <span class="display-5 mb-0 text-primary" style="font-weight:bolder;">{{subscriptionAmount}}</span>
        <span>/</span>
        <span>month</span>
      </div>
      <ul class="ps-1 mb-2">
        <li class="mb-50" v-if="canceled">
          <template v-if="nextPaymentAttempt !== 0">
            <h5 style="font-weight:bolder;">
              Subscription ends on {{nextPaymentAttempt}}
            </h5>
          </template>
          <template v-else="nextPaymentAttempt == 0">
            <h5 style="font-weight:bolder;">
              Subscription Is Inactive
            </h5>
          </template>

        </li>
        <li class="mb-50" v-else><h5 style="font-weight:bolder;"  v-if="!endedAndCanceled">Plan Renews On {{nextPaymentAttempt}}</h5></li>
        <!-- <li class="mb-50">We will send you a notification upon subscription expiration</li> -->
      </ul>
      <div class="d-flex justify-content-between align-items-center fw-bolder mb-50" v-if="!endedAndCanceled">
        <span>Days</span>
        <span>{{paymentBar.subDifference}} of {{paymentBar.totalDay}} Days</span>
      </div>
      <div class="d-flex justify-content-between align-items-start mb-1" v-if="endedAndCanceled">
        <h5 style="font-weight: bolder;">You dont have a subscription.</h5>
      </div>
      <div class="progress mb-50" style="height: 8px" v-else>
        <div class="progress-bar" role="progressbar" :style="{width:paymentBar.percentageDate+'%'}" aria-valuenow="65" aria-valuemax="100" aria-valuemin="80"></div>
      </div>
      <span v-if="canceled">
        <span>Subscription Has Ended.</span>
      </span>
      <!-- <span v-else-if="canceled==''">{{paymentBar.remainingDate}} days remaining until renewal.</span> -->
      <span v-else>
        <span v-if="paymentBar.remainingDate > 0">{{paymentBar.remainingDate}} days remaining until renewal</span>
        <span v-else>Subscription Did End.</span>
      </span>

      <div class="d-grid w-100 mt-2" v-if="endedAndCanceled">
        <!-- <button class="btn btn-light waves-effect waves-float waves-light col-12" data-bs-target="#upgradePlanModal" data-bs-toggle="modal" v-on:click="showDelete('resume')">
          Resume Subscription
        </button> -->
      </div>
      <div class="d-grid w-100 mt-2" v-else>
        <button class="btn btn-light waves-effect waves-float waves-light col-12" data-bs-target="#upgradePlanModal" data-bs-toggle="modal" v-on:click="showDelete('resume')" v-if="canceled">
          Resume Subscription
        </button>
        <button class="btn btn-warning waves-effect waves-float waves-light col-12" data-bs-target="#upgradePlanModal" data-bs-toggle="modal" v-on:click="showDelete('cancel')" v-else>
          Cancel subscription
        </button>
      </div>
    </div>
    <!-- show user view that canceled -->
    <div v-else>
      <h4 class="mb-2" style="font-weight:bolder;">
        Canceled Subscription
      </h4>
      <div class="d-flex justify-content-between align-items-start mb-1">
        <span class="badge bg-light-primary text-sm" style="font-size:11px;">{{plan.title}}</span>
      </div>
      <div class="d-flex justify-content-start mb-1">
        <sup class="h5 pricing-currency text-primary mt-0 mb-0"></sup>
        <span class="display-5 mb-0 text-primary" style="font-weight:bolder;">{{subscriptionAmount}}</span>
        <span>/</span>
        <span>month</span>
      </div>
      <h5 style="font-weight:bolder;">
        Subscription Ends On:
      </h5>
      <h6>
        {{endsAt}}
      </h6>

      <button class="btn btn-light waves-effect waves-float waves-light col-12 mt-2" data-bs-target="#upgradePlanModal" data-bs-toggle="modal" v-on:click="showDelete('resume')" v-if="canceled">
        Resume Subscription
      </button>

    </div>
    <!-- end show user view that canceled -->
  </b-card>
  <b-card v-else>
    <div class="d-flex justify-content-center align-items-start mb-1">
      <h2 class="badge bg-light-warning " style="font-size:16px;">No Active Subscription</h2>
    </div>
  </b-card>
  <!-- confirm  -->
    <div id="sweetAlertDelete" class="swal2-container swal2-center swal2-backdrop-show" style="overflow-y: auto;" v-if="deleteShow">
        <div aria-labelledby="swal2-title" aria-describedby="swal2-html-container" class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: grid;">
            <button type="button" class="swal2-close" style="display: none;" aria-label="Close this dialog">×</button>
            <ul class="swal2-progress-steps" style="display: none;"></ul>
                <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
                    <div class="swal2-icon-content">!</div>
                </div>
                <img class="swal2-image" style="display: none;">
                <h2 class="swal2-title" id="swal2-title" style="display: block;">
                    Are you sure ?
                </h2>
                <div class="swal2-html-container" style="display: block;">
                    You won't be able to revert!
                </div>
                <input class="swal2-input" style="display: none;">
                <input type="file" class="swal2-file" style="display: none;">
                <div class="swal2-range" style="display: none;">
                    <input type="range">
                    <output></output>
                </div>
                <select class="swal2-select" style="display: none;"></select>
                <div class="swal2-radio" style="display: none;"></div>
                <label for="swal2-checkbox" class="swal2-checkbox" style="display: none;">
                    <input type="checkbox">
                    <span class="swal2-label"></span>
                </label>
                <textarea class="swal2-textarea" style="display: none;"></textarea>
                <div class="swal2-validation-message" id="swal2-validation-message" style="display: none;"></div>
                <div class="swal2-actions">
                    <div class="swal2-loader"></div>
                    <button type="button" class="swal2-confirm btn btn-primary" style="display: inline-block;" aria-label="" v-on:click="cancelSubscription" v-if="type=='cancel'">
                      Yes, cancel subscription!
                    </button>
                    <button type="button" class="swal2-confirm btn btn-primary" style="display: inline-block;" aria-label="" v-on:click="resumeSubscription" v-if="type=='resume'">
                      Yes, resume subscription!
                    </button>

                    <button type="button" class="swal2-deny mr-10" style="display: none;" aria-label="" v-on:click="showDelete">No</button>&nbsp;&nbsp;&nbsp;
                    <button id="closeDeleter" type="button" class="swal2-cancel btn btn-outline-danger ms-1" style="display: inline-block;" aria-label="sweetAlertDelete" v-on:click="showDelete">Cancel</button>
                </div>
                <div class="swal2-footer" style="display: none;"></div>
                <div class="swal2-timer-progress-bar-container">
                <div class="swal2-timer-progress-bar" style="display: none;"></div>
            </div>
        </div>
      </div>
    <!-- end confirm delete -->
</template>
<script>
  import { BCard } from "bootstrap-vue-3"
  export default{
    name:"UserPlanView",
    components:{
      BCard
    },
    data(){
      return{
        plan:'Plan',
        userID:'',
        nextPaymentAttempt:'',
        subscriptionAmount:'',
        paymentBar:{},
        deleteShow:false,
        showRenew:'',
        type:'',
        showSubview:false,
        canceled:false,
        endedAndCanceled:false,
        endsAt:''

      }
    },
    created() {
        this.getUserList();
    },
    methods: {
        getUserList(){
            let status ={
                status:0
            }
            const route = this.$router.resolve(
                {
                    name: 'user-show',
                    params: {
                        user: this.$route.params.user
                    }
                }
            );
            axios.get(
                route.href,
                status
            ).then(({data})=>{
                this.plan = data.data.plan;
                this.nextPaymentAttempt = data.data.nextPaymentAttempt;
                this.subscriptionAmount = data.data.subscriptionAmount;
                this.paymentBar = data.data.paymentBar;
                this.canceled = data.data.canceled;
                this.endedAndCanceled = data.data.endedAndCanceled;
                this.userID=data.data.user.id;
                this.showSubview =data.data.showSubview
                this.endsAt = data.data.endsAt
            }).catch();
        },
        showDelete(type){
            this.type = type;
            if(this.deleteShow) {
                this.deleteShow = false
            }
            else {
                this.deleteShow = true
            }
        },
        cancelSubscription(){
            let url = window.location.href;
            let userID = url.split('/').slice(-1)[0]
            axios.post(`/administrant/user/cancel/${userID}`).then(({data})=>{
            if(!data.error){
                toastr.success(data.message,'success');
                setTimeout(()=>{
                    window.location.reload()
                },3000);
            }else{
                toastr.error(data.message,'error');
            }
            }).catch();
        },
        resumeSubscription(){
          let url = window.location.href;
          let userID = url.split('/').slice(-1)[0]
          // alert();
          axios.post(`/administrant/user/renew/${userID}`).then(({data})=>{
            if(!data.error){

              toastr.success(data.message,'success');
              setTimeout(()=>{
                window.location.reload()
              },3000);
            }else{
              toastr.error(data.message,'error');
            }
          }).catch();
        }
    },
  }
</script>
